const SkeletonButton = () => {
  return <div className="w-full min-h-[50px] px-5 py-[10px] bg-gray-100"></div>
}

export default SkeletonButton
